import { motion } from "framer-motion";

export const PRIMARY = "bg-[color:var(--rb-accent)] text-[color:var(--rb-void)] hover:bg-[color:var(--rb-accent-2)] focus-visible:ring-2 focus-visible:ring-[color:var(--rb-accent)]";
export const SECONDARY = "bg-transparent border border-[color:var(--rb-border-strong)] text-[color:var(--rb-text)] hover:border-[color:rgba(124,247,230,0.4)]";

export const SAMPLE_SKILL = `---
name: invoice-parser
description: Extracts line items, totals and vendor
  info from PDF invoices. Use when the user uploads
  an invoice or asks to pull structured data.
---

# Invoice Parser

1. Read the PDF with scripts/parse.py
2. Pull vendor, date, line items, subtotal, tax, total
3. Return clean JSON + a markdown summary table`;

export const ILLUSTRATIVE = [
  { d: "1", v: 2 }, { d: "2", v: 5 }, { d: "3", v: 4 }, { d: "4", v: 9 },
  { d: "5", v: 7 }, { d: "6", v: 14 }, { d: "7", v: 19 },
];

export function Reveal({ children, delay = 0, className = "" }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 14 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.24, ease: "easeOut", delay }}
      className={className}
    >
      {children}
    </motion.div>
  );
}

export const Kicker = ({ children }) => (
  <div className="rb-mono mb-3 inline-flex items-center gap-2 rounded-full border border-[color:var(--rb-border)] bg-[color:var(--rb-surface)] px-3 py-1 text-xs text-[color:var(--rb-accent)]">
    {children}
  </div>
);
